import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  SearchContactTypeModel,
} from '../../../core/models/contact-type.model'
import { MatButtonModule } from '@angular/material/button'
import { MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'


import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { DocumentTypeService } from '../../../core/services/document/document-type/document-type.service'
import { MatIconModule } from '@angular/material/icon'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table'
import { provideNgxMask } from 'ngx-mask'
import { PassengerService } from '../../../core/services/passenger/passenger.service'
import { PassengerOrdemService } from '../../../core/services/passenger/passenger-os/passenger-os.service'
import { MatProgressSpinner, MatSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatDividerModule } from "@angular/material/divider";
import {MatCard, MatCardTitle} from '@angular/material/card';

@Component({
  selector: 'passengers-import-excel',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatIconModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDividerModule,
    MatProgressSpinner,
    MatCard,
    MatCardTitle,
  ],
  templateUrl: './passengers-import-excel.component.html',
  styleUrl: './passengers-import-excel.component.scss',
  standalone: true,
  providers: [
    provideNgxMask({
      dropSpecialCharacters: false,
    }),
  ],
})
export class PassagersImportExcelComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PassagersImportExcelComponent>,
    private dialog: MatDialog,
    private passangerService: PassengerService,
    private passangerOs: PassengerOrdemService,
    private documentTypeService: DocumentTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() response = new EventEmitter<any>()

  form!: FormGroup
  passengers: any[] = [] // Agora a lista vem da API
  loading = false

  documentMask = ''
  cellphoneMask = '(00) 00000-0000'

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  passengerOsList: any[] = []
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  idForOs: any = ''
  editIndex: number | null = null
  editAgendaItem: any = null
  allowedTypes = []
  file: File | null = null
  importResult: any = null

  ngOnInit(): void {
    this.createForm()
  }

  checkDocAvailability(doc: string) {
    this.passangerService.searchPassengerByDocument(doc).subscribe({
      next: (res) => {},
      error: (err) => {
        console.error('Erro ao buscar passageiros', err)
      },
    })
  }

  createFile() {
    if (!this.file) return

    this.loading = true
    const formData = this.createModelExcel()

    this.passangerService.excelImportPassenger(formData).subscribe({
      next: (res: any) => {
        this.importResult = res.data
        this.response.emit({ action: 'create', item: res })
      },
      error: (err) => {
        this.snackbar.errorRequest(err)
        this.loading = false
      },
      complete: () => {
        this.loading = false
        this.resetForm()
      },
    })
  }

  createModelExcel(): FormData {
    const formData = new FormData()
    formData.append('excelFile', this.file!, this.file!.name)
    formData.append('contratoId', this.data.idContrato)
    return formData
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      // nomePassageiro: ['', [Validators.required]],
      // tipoDocumento: [''],
      // numeroDoc: [''],
      // contato: [''],
      // horaChegada: [''],
      // horaSaida: [''],
      // voo: [''],
      // companhia: [''],
      file: ['', [Validators.required]],
    })
  }

  closeModal() {
    this.dialogRef.close()
  }

  onDragOver(event: DragEvent) {
    event.preventDefault()
    event.stopPropagation()
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault()
    event.stopPropagation()
  }

  onDrop(event: DragEvent) {
    event.preventDefault()
    event.stopPropagation()

    const files = event.dataTransfer?.files
    if (files && files.length > 0) {
      this.handleFile(files[0])
    }
  }

  handleFile(file: File) {
    // Atualiza o form
    this.form.patchValue({
      file: file.name,
    })

    this.file = file
    this.form.get('file')?.setValue(this.file.name)
  }

  onFileSelected(event: Event): void {
    console.log(event, ' evento')
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.file = input.files[0]
      this.form.get('file')?.setValue(this.file.name)
    }
    this.form.valid
  }

  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  cancel() {
    this.editIndex = null
    this.file = null
    this.resetForm()
  }

  resetForm() {
    this.form.reset()
    this.file = null
  }
}
